import React from 'react';
import { makeStyles, Chip } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    color: '#131313',
    fontFamily: 'sharp_sans_semi',
    fontSize: '10px',
    lineHeight: 2,
    letterSpacing: '0.6px',
    border: '1px solid #cfcecc',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    bottom: '3px'
  },
  label: {
    paddingLeft: '5px',
    paddingRight: '5px'
  },
  sizeSmall: {
    height: '20px'
  }
}));

export default function StoreClosedBadge(props) {
  const classes = useStyles();

  return (
    <Chip
      {...props}
      size="small"
      label="STORE CLOSED"
      classes={{ ...classes }}
    />
  );
}
